import React from 'react';
import styled from 'styled-components';

import { colors } from 'helpers/ColorHelper';
import { media } from 'helpers/MediaHelper';

const StyledTenantInformationContainer = styled.div`
  width: 100%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  padding: 1rem 2rem;
  align-items: center;
  box-shadow: var(--box-shadow);
  z-index: 1;
  ${media.mobile`
        flex-direction: column;
        align-items: flex-start;
    `};
`;

const StyledConversationName = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`;

const StyledConversationTenant = styled.a`
  color: ${colors.ULTRAMARINE_BLUE};
  display: inline-block;
  margin-left: 0.7rem;
  ${media.mobile`
        margin-left: 0;
        display: block;
    `};
`;

export const ChatTenantInformation = ({ conversation }) => {
  const conversationName = conversation.site_name
    ? `${conversation.site_name} - ${conversation.name}`
    : conversation.name;
  return (
    <StyledTenantInformationContainer>
      <StyledConversationName>{conversationName}</StyledConversationName>
      <div>
        {conversation.cotenants.map(cotenant => (
          <StyledConversationTenant
            href={`/companies/tenants?tenantId=${cotenant.cotenant_id}`}
            target="_blank"
            key={`cotenant-link-${cotenant.cotenant_id}`}
          >
            {cotenant.name}
          </StyledConversationTenant>
        ))}
      </div>
    </StyledTenantInformationContainer>
  );
};
